

export const TwoDayPresentation = () => {
  const tours = ['Acatenango',];
  return (
    <div className="two-day-tour-presentation">
        {
            tours.map( (tour, i) => {
                return (<img src={`../assets/twoDayTours/${tour}.jpg`} className={`two-day-tour-presentation-img`} alt={tour} key={`${i}-Two-Day-Tour-${tour}`} />);
            })
        }
    </div>
  )
}
